<template>
  <div class="vx-row">
    <div class="w-full vx-col">

      <vx-card :title="'CARRIERS'" class="">
        <template slot="actions">
          <vs-button v-can="'edit-carriers-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="carrier-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="carriers">
              <template slot="thead">
                <vs-th width="75%">NAME</vs-th>
                <vs-th width="25%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td>
                    <div class="justify-start vx-row" v-can="'edit-carriers-setting'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr])"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>


                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <create-carrier-pop-up ref="createCarrierPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import CreateCarrierPopUp from "@/components/popups/settings/carriers/CreateCarrierPopUp";

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";

  const CarrierRepository = RepositoryFactory.get('carrier');
  export default {
    name: "CarrierSettings",
    data() {
      return {
        carriers: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      CreateCarrierPopUp
    },
    methods: {
      async refreshData() {
        await this.fetchCarrierList()
      },
      async fetchCarrierList() {
        await this.$vs.loading({
          container: '#carrier-list-table',
          scale: 0.45
        })
        const {data} = await CarrierRepository.getListOfCarriers()
        this.carriers =  data.data
        this.$vs.loading.close('#carrier-list-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.createCarrierPopUp.openPopup()
      },
      async onClickUpdate(data) {
        await this.$refs.createCarrierPopUp.openPopup(data)
      },
      openConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to delete this ?',
          accept: this.onClickDelete,
          parameters: [id]
        })
      },
      async onClickDelete(params) {
        try {
          await CarrierRepository.deleteCarrier(params[0])
          await this.fetchCarrierList()
          await this.showSuccessMessage('Carrier deleted successfully');
        }catch (e) {
            this.convertAndNotifyError(e)
        }
      },
      filterQueryUpdate (){
        this.fetchCarrierList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchCarrierList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchCarrierList()
        }
      },
    },
    async mounted() {
      await this.fetchCarrierList()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchCarrierList()
      },
      perPage() {
        this.fetchCarrierList()
      }
    }
  }
</script>

<style scoped>

</style>
